import { createQuery } from '@tanstack/svelte-query';
import { fetchSceneLoads } from '$lib/api/scene_load';
import { fetchScenes } from '$lib/api/scene';
import type { SceneLoadResponse } from '$lib/types/scene_load';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const sceneLoadsQuery = (scope: ScopeFn) =>
	createQuery<Array<SceneLoadResponse>>(() => {
		const sceneId = resolveScope(scope);
		return {
			queryKey: ['scene_loads', { sceneId }],
			queryFn: async () => {
				const all = await fetchSceneLoads();
				return all.filter((sl) => sl.scene === sceneId);
			},
			enabled: sceneId > 0
		};
	});

export const unitSceneLoadsQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<SceneLoadResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['scene_loads', { unitId }],
			queryFn: async () => {
				const [allSceneLoads, allScenes] = await Promise.all([fetchSceneLoads(), fetchScenes()]);
				const unitSceneIds = new Set(allScenes.filter((s) => s.unit === unitId).map((s) => s.id));
				return allSceneLoads.filter((sl) => unitSceneIds.has(sl.scene));
			},
			enabled: unitId > 0
		};
	});
